import { Typography } from 'components';
import { useTranslations } from 'next-intl';
import { FC } from 'react';

import { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';
import { InvoicePage, Maybe } from 'gql/graphql';
import { TGenericError } from 'types/TGenericError';
import { cn } from 'utils/cn';
import PoCodeEdit from './PoCodeInvoicesEdit';

interface IPoCodeInvoices {
  poCode?: Maybe<string>;
  paid: boolean;
  id: string;
  refetch: (
    options?: RefetchOptions | undefined
  ) => Promise<QueryObserverResult<InvoicePage, TGenericError>>;
}

const PoCodeInvoices: FC<IPoCodeInvoices> = ({ poCode, paid, id, refetch }) => {
  const t = useTranslations();

  return (
    <div className="flex items-center gap-2">
      <Typography
        variant={poCode ? 'medium4' : 'regular4'}
        className={cn(
          'x flex items-center gap-2 ',
          poCode ? 'text-tertiary-100' : 'text-tertiary-200'
        )}
      >
        {poCode ? poCode : t('invoices.not_set')}
        {!paid && <PoCodeEdit poCode={poCode} invoiceId={id} refetch={refetch} />}
      </Typography>
    </div>
  );
};

export default PoCodeInvoices;
